<template>
  <div class="mb-5 mt-4 flex justify-center">
    <img
      src="@/assets/edge-capacity.svg"
      alt="edge capacity logo"
    />
  </div>
  <div class="my-4 mb-8 w-full border-t border-light-gray md:border-none" />
  <layout>
    <form
      novalidate="novalidate"
      @submit.prevent="handleSubmit"
    >
      <div>
        <h3 class="text-left text-3xl text-dark-blue">Open Invitation</h3>
        <p class="mb-3 mt-8 text-left text-body-color">
          Looks like you have an open invitiation from [Dispatcher Service] to
          join their Highway profile. Would you like to accept?
        </p>

        <button-main
          class="my-3 mb-2"
          type="submit"
        >
          Accept
        </button-main>
        <button-main
          type="submit"
          value="Decline"
          variant="secondary"
          class="focused-input"
        >
          Decline
        </button-main>
      </div>
    </form>
  </layout>
</template>

<script>
import Layout from '@/components/LoginLayout.vue';
import ButtonMain from '@/components/Button.vue';
// import { toastResponse } from "@/common/handleServerResponse";

export default {
  name: 'OpenInvitation',
  components: {
    Layout,
    ButtonMain,
  },

  methods: {
    handleSubmit() {
      // TODO -- figure out where these are directed to
      console.log('HANDLE SUBMIT FOR INVITATION');
    },
  },
};
</script>

<style scoped>
p {
  font-size: 14px;
}

.focused-input:focus {
  outline: none !important;
}
</style>
